export default {
    computed: {
		accountHref() {
			if (process.env.VUE_APP_RU_DOMAIN === 'localhost') return 'http://localhost:8081/login'; // assuming that account frontend runs on 8081 port
			return `https://account.${window.location.hostname}`;
		}
	},
};